import { apiService } from "./api.service";
import { MailerSendTemplate, MailerSendTemplateCreate } from "../models/mailersend-template.model";

export class MailerSendTemplateService {
  private static BASE_PATH = "/api/v1/admin/mailersend-templates";

  static async getAll(): Promise<MailerSendTemplate[]> {
    const response = await apiService.get(this.BASE_PATH);
    if (!response.success) return [];
    if (Array.isArray(response.data)) {
      return response.data as MailerSendTemplate[];
    }
    return [];
  }

  static async create(template: MailerSendTemplateCreate): Promise<MailerSendTemplate | null> {
    const response = await apiService.post(this.BASE_PATH, template);
    if (!response.success) return null;
    return response.data as MailerSendTemplate;
  }

  static async update(templateId: string, template: MailerSendTemplateCreate): Promise<MailerSendTemplate | null> {
    const response = await apiService.put(`${this.BASE_PATH}/${templateId}`, template);
    if (!response.success) return null;
    return response.data as MailerSendTemplate;
  }

  static async remove(templateId: string): Promise<boolean> {
    const response = await apiService.delete(`${this.BASE_PATH}/${templateId}`);
    return response.success;
  }
}
